import { Backend } from './BundleBackend';
import i18n from 'i18next';
export function createInstance(modules) {
    return i18n
        .createInstance({
        ns: [],
        backend: {
            modules: modules,
        },
        parseMissingKeyHandler: function (key) {
            return '#_' + key;
        },
        partialBundledLanguages: true,
        returnEmptyString: false,
        appendNamespaceToMissingKey: true,
    })
        .use(Backend);
}
